// Recently Viewed Saga

import { all, call, fork, put, takeEvery, takeLatest } from "redux-saga/effects";

import {
  RECORD_RECENTLY_VIEWED,
  GET_RECENTLY_VIEWED_LIST,
} from "./actionType";

import {
  getRecentlyViewedListSuccess,
  getRecentlyViewedListFail,
} from "./action";

import {
  recordRecentlyViewedAPI,
  getRecentlyViewedListAPI,
} from "../../helpers/fakebackend_helper";

// Record a view event. Fire-and-forget: never disrupt the page the user
// is looking at if logging the view fails.
function* recordRecentlyViewed({ payload }) {
  try {
    yield call(recordRecentlyViewedAPI, [payload]);
  } catch (error) {
    // swallow — view logging is best-effort
  }
}

export function* watchRecordRecentlyViewed() {
  yield takeEvery(RECORD_RECENTLY_VIEWED, recordRecentlyViewed);
}

function* getRecentlyViewedList() {
  try {
    const response = yield call(getRecentlyViewedListAPI);
    yield put(getRecentlyViewedListSuccess(response));
  } catch (error) {
    yield put(getRecentlyViewedListFail(error));
  }
}

export function* watchGetRecentlyViewedList() {
  yield takeLatest(GET_RECENTLY_VIEWED_LIST, getRecentlyViewedList);
}

function* RecentlyViewed() {
  yield all([
    fork(watchRecordRecentlyViewed),
    fork(watchGetRecentlyViewedList),
  ]);
}

export default RecentlyViewed;
